import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.flags.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import compact from 'lodash/compact';
import delay from 'lodash/delay';
import { mapGetters } from 'vuex';
import Heart from '~/components/atoms/Global/Heart.vue';
import { FLASH_TIMER } from '~/const/timers';
import USE_MARKETPLACE from '~/const/marketplace';
var VARIANTS_DISPLAYED = 4;
export default {
  name: 'ProductItem',
  components: {
    Heart: Heart
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    withVariants: {
      type: Boolean,
      default: false
    },
    withWishlist: {
      type: Boolean,
      default: true
    },
    isCategoryTemplate: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      touch: false,
      showSecondImage: false,
      hoverVariant: false,
      hoverVariantArea: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    flagsFilter: function flagsFilter() {
      if (this.isCategoryTemplate && this.product.flags) {
        var flags = this.product.flags.filter(function (flag) {
          return flag.code !== 'FREE_SHIPPING';
        });
        return flags.slice(0, 2);
      }

      return this.product.flags;
    },
    displayedVariants: function displayedVariants() {
      if (!this.product.variants[0].products.length) {
        return [];
      }

      var curProductVariant = {
        images: [this.product.images[0]],
        name: this.product.name,
        reference: this.product.reference,
        slug: this.product.slug
      };
      var variants = this.product.variants[0].products.slice(0, VARIANTS_DISPLAYED);
      variants.unshift(curProductVariant);
      return variants;
    },
    totalVariants: function totalVariants() {
      if (this.product.variants[0].products.length < VARIANTS_DISPLAYED) {
        return false;
      }

      var result = this.product.variants[0].products.length - VARIANTS_DISPLAYED;

      if (result === 0 || result + 2 === 0) {
        return false;
      }

      return {
        desktop: result,
        mobile: result + 2
      };
    },
    variantsVisibility: function variantsVisibility() {
      return this.withVariants && this.product.variants && this.product.variants.length && this.product.variants[0].count;
    },
    currentItem: function currentItem() {
      if (this.hoverVariant) {
        return this.hoverVariant;
      }

      return this.product;
    },
    formattedName: function formattedName() {
      return compact([this.currentItem.line ? this.currentItem.line.toUpperCase() : null, this.currentItem.quantity > 1 ? this.$t('lot', {
        x: this.currentItem.quantity
      }) : null, this.currentItem.name]).join(' - ');
    },
    currentPrice: function currentPrice() {
      return this.product.price.sales.amount ? this.product.price.sales.formatted : this.product.price.base.formatted;
    },
    currentImage: function currentImage() {
      if (this.showSecondImage && this.product.images[1] && !this.hoverVariant) {
        return this.product.images[1];
      }

      if (this.hoverVariant) {
        return this.hoverVariant.images[0];
      }

      return this.product.images[0];
    },
    brandMarketplace: function brandMarketplace() {
      return USE_MARKETPLACE(this);
    }
  }),
  methods: {
    toggleImage: function toggleImage(state) {
      var _this = this;

      delay(function () {
        if (_this.touch) return;
        _this.showSecondImage = state;
      }, FLASH_TIMER);
    }
  }
};